import request from '@/utils/request'

export function getData(data) {
    return request({
        url: '/backend/activity/chakras/getData',
        method: 'post',
        data: data
    })
}

export function getList(data) {
    return request({
        url: '/backend/statistics/channel/data',
        method: 'post',
        data: data
    })
}

export function getOrderList(data) {
    return request({
        url: '/backend/statistics/channel/orderList',
        method: 'post',
        data: data
    })
}

//切换是否计算业绩
export function changeIsAffectPerformance(data) {
    return request({
        url: '/backend/statistics/channel/changeIsAffectPerformance',
        method: 'post',
        data: data
    })
}

export function getOperationList(data) {
    return request({
        url: '/backend/statistics/channel/operations/data',
        method: 'post',
        data: data
    })
}

export function getOperationOrderList(data) {
    return request({
        url: '/backend/statistics/channel/operations/order/list',
        method: 'post',
        data: data
    })
}

//添加新月度绩效统计订单
export function addPerformanceStatisticsOrder(data) {
    return request({
        url: '/backend/statistics/channel/addPerformanceStatisticsOrder',
        method: 'post',
        data: data
    })
}

/**
 * 获取沙龙数据列表
 */
export function getSalonList(data) {
    return request({
        url: '/backend/statistics/channel/salon/data',
        method: 'post',
        data: data
    })
}

/**
 * 获取沙龙数据列表
 */
export function getSalonOrderList(data) {
    return request({
        url: '/backend/statistics/channel/salon/order/list',
        method: 'post',
        data: data
    })
}

/**
 * 删除业绩统计订单
 */
export function deletePerformanceStatisticsOrder(data) {
    return request({
        url: '/backend/statistics/channel/deletePerformanceStatisticsOrder',
        method: 'post',
        data: data
    })
}